import {Platform, StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {white} from '/theme/color/on.color';
import {
  alto,
  green,
  magenta,
  orangeRed,
  pearlGreen,
  salmonPink,
  skyblue,
} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
    ...(Platform.OS === 'web' && {
      maxWidth: MAX_CONTENT_WIDTH,
      width: '100%',
      alignSelf: 'center',
    }),
  },
  content: {
    height: Platform.OS == 'web' ? 600 : 'auto',
    backgroundColor: white,
  },
  scrollViewContainer: {
    flex: 1,
    marginBottom: 120,
    justifyContent: 'center',
  },
  contentLoading: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
  sections: {
    paddingBottom: 60,
  },
  contactWrapper: {
    paddingTop: 0,
    marginBottom: 0,
  },
});

export const dispositionColorByName = {
  ['Ready to Purchase']: green,
  ['On the Fence']: pearlGreen,
  ['Price Issue']: orangeRed,
  ['Not Interested']: alto,
  ['Unable to reach/Invalid data']: magenta,
  ['Do Not Contact']: salmonPink,
  ['New']: skyblue,
};
